import { handleActions, combineActions } from "redux-actions";
import { APP_CONFIG } from "../../../constants";
import { AppState } from "../../../models";
import { AuthAcionTypes } from "../../actions";

const token = localStorage.getItem(APP_CONFIG.LOCAL_STORAGE_KEYS.TOKEN);

let authState: AppState.Authentication = {
  data: token
    ? {
        token,
        // refreshToken: null,
      }
    : null,
  loading: false,
};

export const AuthReducer = handleActions(
  {
    [combineActions(AuthAcionTypes.cacheAuthData).toString()]: (state: AppState.Authentication, action: any) => {
      return { ...state, ...action.payload };
    },
  },
  authState
);
